import { render, staticRenderFns } from "./wechat_bind.vue?vue&type=template&id=32a9f0d9&"
import script from "./wechat_bind.vue?vue&type=script&lang=js&"
export * from "./wechat_bind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports